import { render, staticRenderFns } from "./UgTable.vue?vue&type=template&id=1985eaf3&scoped=true"
import script from "./UgTable.vue?vue&type=script&lang=ts"
export * from "./UgTable.vue?vue&type=script&lang=ts"
import style0 from "./UgTable.vue?vue&type=style&index=0&id=1985eaf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985eaf3",
  null
  
)

export default component.exports